import { type EventFilter } from "@/Modules/Chat/WebSocketManager";
import { type ChatUpdateMessageWebSocket, MessageTypeWebSocket } from "@/Modules/Chat/Models/WebSocket";
import type { ChatStore } from "@/Modules/Chat/Store";

import { useChatStore } from "@/Modules/Chat/Store";

import { isObject } from "@/Utils/Objects";

export interface ChatStateExtraParams {
  chatStore: ChatStore;
}

export const isChatState = (message: unknown): message is ChatUpdateMessageWebSocket => {
  return isObject(message) && message.type === MessageTypeWebSocket.CHAT_UPDATED;
};

export const chatUpdateHandler = (
  chatUpdateMessage: ChatUpdateMessageWebSocket,
  { chatStore = useChatStore() }: ChatStateExtraParams
): Promise<undefined> => {
  if (chatStore.rooms[chatUpdateMessage.data.chat]) {
    chatStore.rooms[chatUpdateMessage.data.chat].blockReason = chatUpdateMessage.data.block_reason;
  }

  return Promise.resolve(undefined);
};

export default {
  isType: isChatState,
  handler: chatUpdateHandler,
} as EventFilter<ChatStateExtraParams>;
